import React, { useEffect, useState } from 'react';
import Styles from '../Styles';
import Button from '../Parts/Button';
import apiCalls from '../PowerShadesAPIFunctions';
import { ZohoInvoice } from '../powershadesApiTypes';

const InvoiceStatus = (props) => {
	const [invoice, setInvoice] = useState<ZohoInvoice | null>(null);
	const [success, setSuccess] = useState(false);
	const [loading, setLoading] = useState(true);

	const { quoteId, close, isPsAdmin, alert } = props;

	useEffect(() => {
		apiCalls.getInvoiceData(quoteId)
			.then((resp) => {
				const { data } = resp;

				setInvoice(data.invoice);
				setSuccess(data.success);
				setLoading(false);
			})
			.catch((err) => {
				console.error('###Error fetching invoice data:', err);
				setSuccess(false);
				setLoading(false);
			});
	}, [quoteId]);

	const updateStatus = async () => {
		try {
			const resp = await apiCalls.updateZohoInvoice(quoteId);
			const { data } = resp;

			alert({ text: 'Command Sent. Data will update.', quickFormat: 'success' });

			setInvoice(data);
		} catch (error) {
			console.error('Error updating invoice:', error);
			alert({ text: 'Failed to update invoice.', quickFormat: 'error' });
		}
	};

	let display: JSX.Element | null = null;
	if (loading) {
		display = <>Loading....</>;
	} else if (success === false) {
		display = (<>
			No invoice found. Invoices after March 12th do not show up on the Dealer Portal.
			Contact PowerShades for assistance.
		</>);
	} else if (success === true && invoice === null) {
		display = <>No Invoice was found.</>;
	} else {
		const [status, description, showPay] = ((inv: ZohoInvoice) => {
			const invStatus = inv.status;
			if (inv.balance === 0.0 && invStatus !== 'draft') {
				return ['Paid', 'The invoice for this order has been paid.', true];
			} else if (invStatus === 'draft') {
				return ['Not Sent.', 'The invoice will be sent once the order is shipped.', false];
			} else if (Date.parse(inv.date) > Date.parse(inv.due_date)) {
				return ['Overdue', 'The invoice for this order is overdue.', false];
			}
			return ['Sent', 'The invoice for this order is sent.', true];
		})(invoice!);

		if (invoice) {
			display = (
				<div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							borderBottom: '1px solid #ccc',
							paddingBottom: '10px'
						}}
					>
						<h3 style={{ margin: 0, color: Styles.psGreen }}>
							Status:
							{' '}
							{status}
						</h3>
						<span style={{ fontSize: '1.1em', fontWeight: 'bold' }}>
							Total: $
							{parseFloat(invoice.total).toFixed(2)}
						</span>
					</div>

					<div>
						<h4 style={{ margin: '0 0 5px 0' }}>Description:</h4>
						<p>{description}</p>
					</div>

					{showPay && (
						<div
							style={{
								display: 'grid',
								gridTemplateColumns: '1fr 1fr',
								gap: '10px',
								backgroundColor: '#f9f9f9',
								padding: '10px',
								borderRadius: '5px'
							}}
						>
							<div>
								<strong>Amount Paid:</strong>
								{' '}
								$
								{ (parseFloat(invoice.total) - invoice.balance).toFixed(2) }
							</div>
							<div>
								<strong>Remaining Balance:</strong>
								{' '}
								$
								{ invoice.balance.toFixed(2) }
							</div>
							<div>
								<strong>Sent Date:</strong>
								{' '}
								{invoice.date}
							</div>
							<div>
								<strong>Due Date:</strong>
								{' '}
								{invoice.due_date}
							</div>
						</div>
					)}
					
					<div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
						<Button color="green" onClick={() => window.open(invoice.invoice_url)}>
							Pay Here
						</Button>
						{isPsAdmin && (
							<Button color="green" onClick={updateStatus}>
								Update Invoice
							</Button>
						)}
					</div>
				</div>
			);
		}
	}

	return (
		<div className="admin-payment" style={{ overflow: 'hidden auto', padding: '20px' }}>
			<h2
				style={{
					color: Styles.psGreen,
					marginBottom: '20px',
					borderBottom: `2px solid ${Styles.psGreen}`,
					paddingBottom: '10px'
				}}
			>
				Invoice Status
			</h2>
			<div style={{ marginBottom: '20px' }}>{display}</div>
			<div style={{ textAlign: 'right' }}>
				<Button color="green" onClick={close}>
					Close
				</Button>
			</div>
		</div>
	);
};

export default InvoiceStatus;
